import React, { useEffect } from "react";
import BasePage from "components/BasePage";
import "./style.scss";
import BlockMeasuringSuccess from "./components/BlockMeasuringSuccess";
import BlockServices from "./components/BlockServices";
import BlockServicesPracticeAreas from "./components/BlockServicesPracticeAreas";
import BlockUniversityWorkshops from "./components/BlockUniversityWorkshops";

export default function PageServices() {
  useEffect(() => {
    const main = document.querySelector(".main");
    main?.classList.add("bg-white");
    return () => main?.classList.remove("bg-white");
  }, []);

  return (
    <BasePage className="page-services">
      <BlockServices />
      <BlockUniversityWorkshops />
      <BlockMeasuringSuccess />
      <BlockServicesPracticeAreas />
    </BasePage>
  );
}
